<template>
  <b-modal id="ver-factura-modal" size="xl" scrollable centered>
    <div v-html="facturaHtml"></div>
  </b-modal>
</template>
<script>
import { get } from "lodash-es";
export default {
  props: ["situacionCliente"],
  computed: {
    facturaHtml() {
      return get(this.situacionCliente, "codigo_html", "");
    },
  },
};
</script>
